import { HttpClient } from '@seller/gilgamesh-web-http-client';

import messageHandler from '../utils/message';
import spinner from '@/utils/spinner';
import version from '@/storages/version';

const interceptors = {
  request: {
    onFulfilled (config) {
      config.headers.feversion = '4.0.0';
      config.headers['cookie-enabled'] = navigator.cookieEnabled;

      if (!config.hideSpinner) {
        spinner.start();
      }
      return config;
    },
    onRejected (error) {
      spinner.done();
      messageHandler.error('Beklenmeyen bir hata oluştu. Lütfen uygulamanızı kapatıp yeniden deneyiniz.');
      error.isRequestRejected = true;
      return Promise.reject(error);
    },
  },
  response: {
    onFulfilled (response) {
      if (!response.config.hideSpinner) {
        spinner.done();
      }
      return response;
    },
    onRejected (error) {
      spinner.done();
      return Promise.reject(error);
    },
  },
  responseError: {
    onFulfilled (response) {
      return response;
    },
    onRejected (e) {
      const hideErrorMessage = e.config && e.config.hideErrorMessage;
      let message = e.response && e.response.data && e.response.data.errors.length ? (e.response.data.errors[0].message || e.response.data.message) : e.message;
      if (!hideErrorMessage && !e.isRequestRejected) {
        message = String(message).includes('undefined') || String(message).includes('Network Error') ? 'Sistemsel bir hata oluştu. Sayfayı yenileyerek tekrar deneyiniz!' : message;
        messageHandler.error(message || 'Bir Hata oluştu.');
      }

      spinner.done();
      return Promise.reject(e);
    },
  },
};

const options = {
  requestInterceptors: [interceptors.request],
  responseInterceptors: [interceptors.response, interceptors.responseError],
  refreshTokenUrl: process.env.VUE_APP_REFRESH_TOKEN_URL,
  version: version.get(),
};

export default new HttpClient(
  process.env.VUE_APP_SELLER_PRODUCT_BFF,
  options,
);
